import { Footer } from "./footer/Footer";
import { Header } from "./header";

export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div data-color="unbranded">
      <Header />
      <div className="flex flex-col min-h-screen-header-footer-mobile lg:min-h-screen-header-footer">
        {children}
      </div>
      <Footer />
    </div>
  );
};
